// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as Card from "../../resources/layout-and-structure/Card.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PricePurchaseTableEditCellWrapper from "../Price/PricePurchaseTableEditCellWrapper.res.js";
import * as CatalogSupplierTableEditCellWrapper from "./CatalogSupplierTableEditCellWrapper.res.js";

function keyExtractor(row) {
  return row.variantId + "-purchase";
}

let Row = {
  keyExtractor: keyExtractor
};

function tableColumns(allShopsFiltered) {
  return [
    {
      key: "purchasedprice-shopname",
      name: I18n.t("Shop/Warehouse"),
      layout: {
        hidden: !allShopsFiltered,
        minWidth: {
          NAME: "px",
          VAL: 200
        },
        width: {
          NAME: "fr",
          VAL: 1.75
        }
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: param.data.shopName
      })
    },
    {
      key: "supplier-id",
      name: I18n.t("Supplier"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 230
        },
        width: {
          NAME: "fr",
          VAL: 2
        }
      },
      render: param => {
        let match = param.data;
        return JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(CatalogSupplierTableEditCellWrapper.make, {
            supplierId: match.supplierId,
            supplierName: match.supplierName,
            variantId: match.variantId,
            shopId: match.shopId
          }),
          spaceRight: "xxlarge"
        });
      }
    },
    {
      key: "purchasedprice-price",
      name: I18n.t("Purchase price") + " " + I18n.t("HT"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 100
        }
      },
      render: param => {
        let match = param.data;
        return JsxRuntime.jsx(PricePurchaseTableEditCellWrapper.make, {
          value: match.purchasePrice,
          formattedPurchasePrice: match.formattedPurchasePrice,
          bulkUnit: match.bulkUnit,
          minRetailPrice: match.minRetailPrice,
          variantId: match.variantId
        });
      }
    }
  ];
}

function CatalogVariantPurchasePriceTableCard(props) {
  let shopsVariantPrices = props.shopsVariantPrices;
  let match = Auth.useScope();
  let allShopsFiltered;
  allShopsFiltered = match.TAG === "Organisation" ? match.activeShop === undefined : false;
  let columns = React.useMemo(() => tableColumns(allShopsFiltered), [allShopsFiltered]);
  let shopsVariantRetailPriceMinValue = React.useMemo(() => shopsVariantPrices.map(param => {
    let priceValues = param.retailPricesData.map(data => data.valueExcludingTax);
    let minPriceValue = Math.min(...priceValues);
    if (isFinite(minPriceValue)) {
      return minPriceValue;
    }
  }), [shopsVariantPrices]);
  let rows = shopsVariantPrices.map((param, index) => {
    let purchasePriceData = param.purchasePriceData;
    let match = shopsVariantRetailPriceMinValue[index];
    let tmp;
    if (match !== undefined) {
      let minRetailPrice = Primitive_option.valFromOption(match);
      tmp = minRetailPrice !== undefined ? minRetailPrice : 0;
    } else {
      tmp = 0;
    }
    return {
      variantId: purchasePriceData.id,
      shopId: purchasePriceData.shopId,
      shopName: purchasePriceData.shopName,
      supplierId: purchasePriceData.supplierId,
      supplierName: purchasePriceData.supplierName,
      purchasePrice: Stdlib_Option.getOr(purchasePriceData.purchasePrice, 0),
      formattedPurchasePrice: purchasePriceData.formattedPurchasedPrice,
      minRetailPrice: tmp,
      bulkUnit: purchasePriceData.capacityUnit
    };
  });
  let placeholderEmptyState = JsxRuntime.jsx(Placeholder.make, {
    status: "NoDataAvailable",
    customText: I18n.t("No purchase price has been yet recorded")
  });
  let data = {
    TAG: "Done",
    _0: {
      TAG: "Ok",
      _0: rows
    }
  };
  return JsxRuntime.jsx(Card.make, {
    children: JsxRuntime.jsx(TableView.make, {
      data: data,
      columns: columns,
      keyExtractor: keyExtractor,
      maxHeight: 325,
      placeholderEmptyState: placeholderEmptyState
    }),
    title: I18n.t("Purchasing price"),
    variation: "table"
  });
}

let make = React.memo(CatalogVariantPurchasePriceTableCard, (oldProps, newProps) => oldProps.shopsVariantPrices === newProps.shopsVariantPrices);

let Config;

export {
  Config,
  Row,
  tableColumns,
  make,
}
/* make Not a pure module */
